/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Approval Status
 */
export type ValidateTransferPeerResponseDataApprovalStatus = typeof ValidateTransferPeerResponseDataApprovalStatus[keyof typeof ValidateTransferPeerResponseDataApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ValidateTransferPeerResponseDataApprovalStatus = {
  APPROVED: 'APPROVED',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  REJECTED: 'REJECTED',
  BYPASSED: 'BYPASSED',
} as const;
